import React from "react";
import { Scientists } from "../../../lib/useScientists";
import { ComponentProps } from "../../../types";
import { SectionWrapper } from "../../containers/SectionWrapper";
import { ContentTile } from "../../elements/ContentTile/ContentTile";
import { Cta } from "../../elements/Cta/Cta";
import { ScientistHero } from "../../elements/ScientistHero/ScientistHero";
import * as styles from "./ScientistOfTheDayListing.module.css";
import { ScientistSearch } from "./ScientistSearch";

interface Props extends ComponentProps {
  scientists?: Scientists[];
  setLoadMore: React.Dispatch<React.SetStateAction<boolean>>;
  hasMore?: boolean;
}

export const ScientistOfTheDayListing: React.FC<Props> = ({
  scientists,
  hasMore,
  setLoadMore,
  ...props
}) => {
  if (!scientists) return null;

  const SCIENTISTS_ROUTE = `/about/news/scientist-of-the-day/`;

  const renderFeaturedScientist = () => {
    let scientist = scientists[0];

    return (
      <ScientistHero
        showCta={true}
        style={{
          backgroundColor: "var(--color-black)",
          color: "var(--color-white)",
        }}
        {...scientist}
        date={scientist.contentTile?.date || scientist.page?.displayPublishDate}
      />
    );
  };

  const renderScientistTiles = () => {
    return scientists.slice(1).map((scientist, idx) => {
      const image = scientist.contentTile?.image || scientist.image?.largeImage;
      const url =
        scientist.contentTile?.ctaHref ||
        (scientist.page?.url?.includes("/")
          ? scientist.page?.url
          : SCIENTISTS_ROUTE + scientist.page?.url);
      const ariaLabel = scientist.contentTile?.ctaAriaLabel
        ? scientist.contentTile?.ctaAriaLabel
        : `Learn More about ${scientist.firstName} ${scientist.lastName}`;
      return (
        <ContentTile
          contentCategory={scientist.contentTile?.contentCategory}
          subhead={
            scientist.contentTile?.subhead ||
            scientist.firstName + " " + scientist.lastName
          }
          text={
            scientist.contentTile?.text || {
              value: `<p>${scientist.pageDescription}</p>`,
            }
          }
          date={
            scientist.contentTile?.date || scientist.page?.displayPublishDate
          }
          image={image}
          ctaLabel={scientist.contentTile?.ctaLabel || "See Details"}
          ctaHref={url}
          ctaAriaLabel={ariaLabel}
          ctaTarget={scientist.contentTile?.ctaTarget || "_self"}
          hideTextOnMobile={false}
          tileWidth="oneThird"
          key={idx}
        />
      );
    });
  };

  return (
    <SectionWrapper {...props}>
      <div className={styles.scientistofthedaylisting}>
        <ScientistSearch />
        {renderFeaturedScientist()}

        <div className={styles.scientistsTiles}>{renderScientistTiles()}</div>
        {hasMore && (
          <div className={styles.loadMoreButton}>
            <Cta
              button={true}
              onClick={() => setLoadMore(true)}
              label={"Show More"}
              green={true}
            />
          </div>
        )}
      </div>
    </SectionWrapper>
  );
};
